import React from "react";
import I18n from "i18n-js";
import './translations';

class EditEntrySquarePayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentBtnIsDisabled: false
        }
        I18n.locale = this.props.locale
        this.setPayAmount = this.setPayAmount.bind(this);
        window.payAmount = this.paymentAmount();
    }

    componentDidMount() {
        $(document).on('change', 'select.js-quantity', ()=>{
            if(jQuery("#card-button")&&jQuery('#owing')){
                jQuery("#card-button").html(`Pay $${Number(jQuery('#owing').val()).toFixed(2)}`)
                this.props.updateTotalOwing(Number(jQuery('#owing').val()).toFixed(2))
            }
        })
        document.dispatchEvent(new CustomEvent('esm:square-payment-ready'));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customAmount !== this.props.customAmount) {
            window.payAmount = this.paymentAmount();
        }
        if(this.isButtonDisabled() !== this.state.paymentBtnIsDisabled){
            this.setState({paymentBtnIsDisabled: this.isButtonDisabled()});
        }
    }

    setPayAmount() {
        window.payAmount = this.paymentAmount();
    }

    paymentAmount() {
        return parseFloat(this.props.customAmount) || 0;
    }

    totalOwing() {
        return parseFloat(this.props.entry_total_owing) || 0;
    }

    displayPayAmountError() {
        if (this.paymentAmount() > this.totalOwing()) {
            return {display: "inline"};
        }
        else if (this.paymentAmount() <= 0.10) {
            return {display: "inline"};
        }
        else{
            return {display: "none"};
        }
    }

    displayPayAmountErrorMessage() {
        if (this.paymentAmount() > this.totalOwing()) {
            return "The inputted amount: $" + this.paymentAmount().toFixed(2) + " is greater than the total amount owed: $" + this.totalOwing().toFixed(2) + ". Please re-enter a valid payment amount.";
        }
        else if (this.paymentAmount() <= 0.10) {
            return "Please enter a payment amount of greater than '0.10'";
        }
    }

    isButtonDisabled() {
        return this.paymentAmount() > this.totalOwing() || this.paymentAmount() <= 0.10;
    }

    render () {
        return (
            <div>
                <div id="invalid-amount-error" style={this.displayPayAmountError()}>{this.displayPayAmountErrorMessage()}</div>
                <div id={"square_payment_form"}>
                    <form id="payment-form">
                        <div id="card-container"></div>
                        <button id="card-button" type="button" disabled={this.state.paymentBtnIsDisabled} onClick={this.setPayAmount}>{I18n.t("pay", {amount: this.paymentAmount().toFixed(2)})}</button>
                    </form>
                    <div id="payment-status-container"></div>
                </div>
            </div>
        )
    }
}

export default EditEntrySquarePayment
